import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { EvaluatorOutletComponent } from "./components/evaluator-outlet/evaluator-outlet.component";
import { EvaluatorHomeComponent } from "./components/evaluator-home/evaluator-home.component";
import { EvaluatorLoginComponent } from "./components/evaluator-login/evaluator-login.component";
import { MaterialModule } from "../material-module";
import { SharedModule } from "../shared/shared.module";
import { EvaluatorApplicantsComponent } from "./components/evaluator-applicants/evaluator-applicants.component";
import { RouterModule } from "@angular/router";
import { EvaluatorDashboardRoutes } from "./evaluator-dashboard.routing";
import { EvaluatorPortalComponent } from "./components/evaluator-application-list/evaluator-application-list.component";
import { EvaluatorViewOutletComponent } from "./components/evaluator-view-outlet/evaluator-view-outlet.component";
import { EvaluatorViewApplicationComponent } from "./components/evaluator-view-application/evaluator-view-application.component";
import { LightboxModule } from "ngx-lightbox"
import { EvaluatorRegisterComponent } from "./components/evaluator-register/evaluator-register.component";
import { DashboardModule } from "../dashboard/dashboard.module";
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { EvaluatorSchedulingComponent } from './components/evaluator-scheduling/evaluator-scheduling.component';
import { NgxScannerQrcodeModule, LOAD_WASM } from 'ngx-scanner-qrcode';
import { EvaluatorScanQrComponent } from './components/evaluator-scan-qr/evaluator-scan-qr.component';
import { EvaluatorSchedulingViewComponent } from './components/evaluator-scheduling-view/evaluator-scheduling-view.component';
import { EvaluatorScanResultComponent } from './components/evaluator-scan-result/evaluator-scan-result.component';
import { EvaluatorReturnModalComponent } from './components/evaluator-return-modal/evaluator-return-modal.component';
import { QRCodeModule } from 'angularx-qrcode';
import { EvaluatorUploadLabresultComponent } from './components/evaluator-upload-labresult/evaluator-upload-labresult.component';
import { FormsModule } from "@angular/forms";
import { BcpoFileModalComponent } from './components/bcpo-file-modal/bcpo-file-modal.component';
import { EvaluatorScannerComponent } from './components/evaluator-scanner/evaluator-scanner.component';
import { EvaluatorScannerOutletComponent } from './components/evaluator-scanner-outlet/evaluator-scanner-outlet.component';
import { EvaluatorEsigResultComponent } from './components/evaluator-esig-result/evaluator-esig-result.component';
import { WorkpermitQrResultComponent } from './components/workpermit-qr-result/workpermit-qr-result.component';
import { EvaluatorVerifyEmailComponent } from './components/evaluator-verify-email/evaluator-verify-email.component';
import { ViewLabResultDetailsComponent } from './components/view-lab-result-details/view-lab-result-details.component';
import { ViewLabResultsHistoryComponent } from './components/view-lab-results-history/view-lab-results-history.component';
import { GeneralRemarksComponent } from './components/general-remarks/general-remarks.component';
import { ForObservationDialogComponent } from './components/for-observation-dialog/for-observation-dialog.component';
import { EvaluatorSuccessComponent } from './components/evaluator-success/evaluator-success.component';


LOAD_WASM().subscribe();

@NgModule({
  declarations: [
    EvaluatorOutletComponent,
    EvaluatorHomeComponent,
    EvaluatorLoginComponent,
    EvaluatorApplicantsComponent,
    EvaluatorPortalComponent,
    EvaluatorViewOutletComponent,
    EvaluatorViewApplicationComponent,
    EvaluatorRegisterComponent,
    EvaluatorSchedulingComponent,
    EvaluatorScanQrComponent,
    EvaluatorSchedulingViewComponent,
    EvaluatorScanResultComponent,
    EvaluatorReturnModalComponent,
    EvaluatorUploadLabresultComponent,
    BcpoFileModalComponent,
    EvaluatorScannerComponent,
    EvaluatorScannerOutletComponent,
    EvaluatorEsigResultComponent,
    WorkpermitQrResultComponent,
    EvaluatorVerifyEmailComponent,
    ViewLabResultDetailsComponent,
    ViewLabResultsHistoryComponent,
    GeneralRemarksComponent,
    ForObservationDialogComponent,
    EvaluatorSuccessComponent,
  ],
  imports: [
    FormsModule,
    NgxScannerQrcodeModule,
    QRCodeModule,
    NgxExtendedPdfViewerModule,
    LightboxModule,
    CommonModule,
    MaterialModule,
    SharedModule,
    RouterModule.forChild(EvaluatorDashboardRoutes),
  ],
})
export class EvaluatorDashboardModule { }
